<template>
    <div>
      <el-row class="mb-20">
        <el-col :span="24">
          <el-table
            :data="items"
            style="width: 100%"
            stripe
            :row-class-name="getClassnameById"
            class="item-table hidden-sm-and-down"
          >
            <el-table-column
              label="Image"
              width="100"
            >
            <template slot-scope="scope">
                <img :src="getImage(scope.row)" width="50" height="50" />
              </template>
            </el-table-column>
            <el-table-column
              label="Item"
              width="200"
              sortable
            >
                <template slot-scope="scope">
                <div class="break-word">{{scope.row.saleableItem.name}}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="price"
              label="Price"
              width="100"
              sortable
            >
              <template slot-scope="scope">
                  {{ priceFormatter(scope.row.saleableItem.price) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="size"
              label="Size"
              min-width="100"
              sortable
            >
            <template slot-scope="scope">
                  {{ scope.row.saleableItem.size }}
              </template>
            </el-table-column>
            <el-table-column
              prop="qty"
              label="Quantity"
              min-width="100"
            >
            <template slot-scope="scope">
                  {{ scope.row.saleableItem.qty }}
              </template>
            </el-table-column>
            <el-table-column
              prop="createdAt"
              label="Date Purchased"
              min-width="200"
              sortable
            >
            <template slot-scope="scope">
                  {{ dateFormatter(get(scope, 'row.pinCharge.createdAt')) }}
              </template>
            </el-table-column>
            <el-table-column label="" width="70" align="center" fixed="right">
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">
                    <span>Download Receipt</span>
                  </div>
                  <span>
                    <el-button size="small" type="danger" @click="downloadReceipt(scope.row)">
                      <i class="el-icon-download"></i>
                    </el-button>
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

          <el-table
            :data="registrations"
            border
            stripe
            class="item-table hidden-md-and-up"
          >
          <el-table-column
              label="Image"
              width="100"
            >
            <template slot-scope="scope">
                <img :src="getImage(scope.row)" width="50" height="50" />
              </template>
            </el-table-column>
          <el-table-column
              label="Item"
              width="200"
              sortable
            >
                <template slot-scope="scope">
                <div class="break-word">{{scope.row.saleableItem.name}}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="entityType"
              label="Purchased From"
              min-width="250"
              sortable
            >
            <template slot-scope="scope">
              <div class="break-word">{{ getPurchasedFrom(scope.row) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="price"
              label="Price"
              width="100"
              sortable
            >
              <template slot-scope="scope">
                  {{ priceFormatter(scope.row.saleableItem.price) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="size"
              label="Size"
              min-width="100"
              sortable
            >
            <template slot-scope="scope">
                  {{ scope.row.saleableItem.size }}
              </template>
            </el-table-column>
            <el-table-column
              prop="qty"
              label="Quantity"
              min-width="100"
            >
            <template slot-scope="scope">
                  {{ scope.row.saleableItem.qty }}
              </template>
            </el-table-column>
            <el-table-column
              prop="createdAt"
              label="Date Purchased"
              min-width="200"
              sortable
            >
            <template slot-scope="scope">
                  {{ dateFormatter(get(scope, 'row.pinCharge.createdAt')) }}
              </template>
            </el-table-column>
            <el-table-column label="Operations" width="190">
              <template slot-scope="scope">
                <el-button type="danger" size="small" @click="downloadReceipt(scope.row)">
                  Download Receipt
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </template>

<script>
import _, { startCase } from 'lodash';
import moment from 'moment-timezone';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { fileUploadAcceptString } from '../../../utils/constants';

export default {
  components: { },
  props: {
    value: Object,
  },
  data() {
    return {
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      key: 0,
      capitalize: _.capitalize,
      registrations: [],
      items: [],
      membershipToRegister: {},
      fileUploadAcceptString,
      get: _.get,
      showQsDialog: false,
      dialogValue: {
        filtersVisible: false,
        entityType: undefined,
        registration: undefined,
        regoDetails: undefined,
      },
    };
  },
  mounted() {
    if (this.value._id) {
      this.$store.commit('loading', true);
      this.$http.get(`/assemble/api/v1/portal/registrations/members/${this.value._id}/users/${this.userId}/store-purchase-history`)
        .then((res) => {
          console.log({
            res
          });
          const storePurchaseHistory = _.get(res, 'data.data', []);
          // eslint-disable-next-line no-restricted-syntax
          for (const storePurchase of storePurchaseHistory) {
            console.log({
              storePurchase
            });
            const purchaseItems = _.get(storePurchase, 'items', []);
            console.log({
              purchaseItems
            });
            const items = _.map(purchaseItems, (item) => ({
              ...item,
              entityType: storePurchase.entityType,
              saleableItem: item,
              purchase: storePurchase,
              pinCharge: _.get(storePurchase, 'pinCharge', {}),
            }));
            this.items = [...this.items, ...items];
          }
          console.log({
            items: this.items
          });
          this.$store.commit('loading', false);
        })
        .catch((e) => {
          this.$message.error(e);
          this.$store.commit('loading', false);
        });
    }
  },
  methods: {
    getImage(row) {
      if (_.get(row, 'saleableItem.images[0].url')) {
        return _.get(row, 'saleableItem.images[0].url');
      }
      return this.logo;
    },
    priceFormatter(value) {
      // return `$${value / 100}`;
      const price = value / 100;
      return price ? `$${(price).toFixed(2)}` : '$0';
    },
    async downloadReceipt(item) {
      console.log({
        receiptItem: item
      });
      let charges = [];
      try {
        const response = await this.$http.get(`/assemble/api/v1/portal/saleable-items/${item.purchase._id}/purchase-receipt`);
        charges = response.data.data;
        console.log({
          charges
        });
      } catch {
        this.$message.error('An error occured while downloading receipt');
      }

      if (pdfMake.vfs === undefined) {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      if (!charges.length) this.$message.success('This item did not incur any cost thus no receipt was found');

      let logo = '';
      let isURL = false;
      if (process.env.VUE_APP_LOGO && process.env.VUE_APP_LOGO !== '') {
        logo = process.env.VUE_APP_LOGO;
        isURL = true;
      }

      const dd = await this.$http.post('/assemble/api/v1/portal/saleable-items/receipt-content', {
        member: this.value, charges, logo, isURL, type: 'member', purchase: item
      });

      if (!isURL) {
        dd.data.data.content.unshift({ image: 'logo', width: [100], alignment: 'center' });
        dd.data.data.images = { logo: await this.getBase64Logo() };
      }

      console.log(dd);

      pdfMake.createPdf(dd.data.data).download(`${item.purchase._id}-${dd.data.chargeId}.pdf`);
    },
    dateFormatter(timestamp) {
      console.log({
        timestamp,
        timezone: this.timezone
      });
      return moment(timestamp).tz(this.timezone).format('DD MMM YYYY, HH:mm');
    },
  },
  computed: {
    timezone() {
      return this.$store.getters['national/timezone'];
    },
    userId() {
      return this.$store.getters['user/userId'];
    },
  },
  filters: {
    startCase,
    cap(value) {
      return _.capitalize(value);
    },
    formatDate(date) {
      return moment(date).tz(this.timezone).format('DD MMM YYYY, HH:mm');
    },
  }
};
</script>

  <style lang="scss" scoped>
  ::v-deep .item-table {
    border: 1px solid rgba(45, 58, 69, 0.1);

    th {
      background: #f6f8fa !important;
      padding-right: 1em;
      text-align: left;
      height: 48px;
    }

    td {
      background-color: white !important;
      padding: 14px 8px;
      text-align: left;
    }
  }

  .break-word {
    word-break: break-word;
  }

  /* Clean table styling from RegoHistory */
  ::v-deep .el-table {
    border: 1px solid #EBEEF5 !important;
    border-radius: 4px !important;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03) !important;
  }

  ::v-deep .el-table th {
    background-color: #F5F7FA !important;
    font-weight: 500 !important;
    color: #606266 !important;
    border-bottom: 1px solid #EBEEF5 !important;
    padding: 10px 0 !important;
  }

  ::v-deep .el-table td {
    border-bottom: 1px solid #EBEEF5 !important;
    padding: 14px 8px !important;
  }

  ::v-deep .el-table td, ::v-deep .el-table th {
    border-right: 1px solid #EBEEF5 !important;
  }

  ::v-deep .el-table td:last-child, ::v-deep .el-table th:last-child {
    border-right: none !important;
  }

  ::v-deep .el-table tr:hover > td {
    background-color: #F5F7FA !important;
  }

  ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #FAFBFC;
  }
  </style>
